// extracted by mini-css-extract-plugin
module.exports = {"unsetCursor":"index_unsetCursor_RAmj2"};